import React from "react";

const CPP_Quiz = () => {
  return (
    <div>
      <h1>CPP_Quiz Component</h1>
      <p>Content for CPP_Quiz goes here...</p>
    </div>
  );
};

export default CPP_Quiz;
